module.exports = __webpack_public_path__ + "static/media/battery-slash.24c3321f.svg";